import type {
  WhereToStartDetailParams,
  WhereToStartLists,
  WhereToStartParams,
  WhereToStartRank,
  WhereToStartRemaining,
  WhereToStartSearch,
  WhereToStartStartDetail,
} from "@atlas/shared";
import { apiGet } from "../lib/api-client";

export type {
  StartSummary,
  WhereToStartDetailParams,
  WhereToStartHill,
  WhereToStartListRef,
  WhereToStartListSummary,
  WhereToStartLists,
  WhereToStartMode,
  WhereToStartParams,
  WhereToStartRank,
  WhereToStartRegionMarker,
  WhereToStartRemaining,
  WhereToStartRemainingPeak,
  WhereToStartSearch,
  WhereToStartSearchResult,
  WhereToStartStartDetail,
  WhereToStartStartType,
} from "@atlas/shared";

// Where to start (spec 31 / ATL-146). Never a 402: free accounts get
// gated: true and the free shape.

function qs(params: WhereToStartParams, bearing?: number): string {
  const q = new URLSearchParams();
  q.set("lists", params.lists.join(","));
  if (params.loop != null) q.set("loop", String(params.loop));
  if (params.mode) q.set("mode", params.mode);
  if (params.startType && params.startType !== "any") q.set("startType", params.startType);
  if (params.lat != null && params.lng != null) {
    q.set("lat", params.lat.toFixed(3));
    q.set("lng", params.lng.toFixed(3));
    if (params.radius != null) q.set("radius", String(params.radius));
  }
  if (bearing != null) q.set("bearing", bearing.toFixed(1));
  return q.toString();
}

export function fetchWtsLists(): Promise<WhereToStartLists> {
  return apiGet("/where-to-start/lists");
}

export function fetchWtsRemaining(lists: string[]): Promise<WhereToStartRemaining> {
  return apiGet(`/where-to-start/remaining?lists=${encodeURIComponent(lists.join(","))}`);
}

export function fetchWtsRank(params: WhereToStartParams): Promise<WhereToStartRank> {
  return apiGet(`/where-to-start/rank?${qs(params)}`);
}

export function fetchWtsStart(id: string, params: WhereToStartDetailParams): Promise<WhereToStartStartDetail> {
  return apiGet(`/where-to-start/starts/${encodeURIComponent(id)}?${qs(params, params.bearing)}`);
}

export function searchWts(q: string): Promise<WhereToStartSearch> {
  return apiGet(`/where-to-start/search?q=${encodeURIComponent(q)}`);
}
